import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Alert, Button, Card, CardBody, CardGroup, Col, Container,
    Input, InputGroup, InputGroupAddon, InputGroupText, Row,
    Modal,
} from 'reactstrap';
import logo from '../../../assets/img/brand/logo.png';
import { login } from '../../../api/Login'
import * as actions from '../../../actions';
import { submitChangePassword } from '../../../api/ChangePassword';
import { signupvarifyphone } from '../../../api/SignUp';
import { AppConfiguration } from "read-appsettings-json";
import { LoadingSpinner } from "../../../components";
import Dashboard from '../../Dashboard/Dashboard';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            changeScreen: false,
            errorMessage: "",
            loginId: "",
            userId: 0,
            displayName: "",
            password: "",
            newPassword: "",
            confirmPassword: "",
            attempts: 0,
            rowKey: 0,
            attemptsMessge: "",
            timestamp: undefined,
            isMember: false,
            roleName: "",
            isOTPConfirm: false,
            OTPModal: false,
            isTimeout: false,
            isLoading: false,
        }
    };
    componentDidMount() {
        if (this.props.location.state === 0) {
            this.setState({ isOTPConfirm: true });
        }
    }
    updateState(prop, value) {
        if (prop === "loginId") this.setState({ attempts: 0 })
        this.setState({
            [prop]: value
        })
    }
    validateChangePassword() {
        if (this.state.newPassword !== this.state.confirmPassword && this.state.confirmPassword !== "") {
            this.setState({
                errorMessage: "password do not match"
            })
            return false;
        } else if (this.state.newPassword === "" || this.state.confirmPassword === "") {
            this.setState({
                errorMessage: "all fields must be fill"
            })
            return false;
        }

        return true
    }
    validate() {
        if (this.state.loginId === "" || this.state.password === "") {
            this.setState({
                errorMessage: `Missing Credentials`,
                isLoading: false,
            })
            return false;
        }
        return true
    }
    ToCancel() {
        this.setState({ OTPModal: false })
    }
    async ChangePassword() {
        if (this.validateChangePassword() === false) return;
        this.setState({ errorMessage: "" })
        let chgres = await submitChangePassword(this.state);
        if (chgres.status) {
            let { pathname } = window.location;
            if (pathname === '/Login') {
                this.props.history.push({ pathname: Dashboard.routeName })
            }
        } else {
            this.setState({
                errorMessage: chgres.message
            })
        }
    }
    submitHandle = async (e) => {
        e.preventDefault();
        this.setState({ isLoading: true, errorMessage: "" });
        if (this.validate() === false) return;
        let response = await login(this.state, "");

        if (response.status) {
            if (response.data.isAuth === false) {
                let varifyphone = await signupvarifyphone(this.state.loginId);
                console.log("varigyphone", varifyphone);
                if (varifyphone.Status === false) {
                    this.setState({ errorMessage: "Something went wrong, Please try again!", isLoading: false });
                } else {
                    //input user is already existed in DB
                    if (varifyphone.data.status === false) {
                        this.setState({ errorMessage: varifyphone.data.message, isLoading: false });
                    }
                }
            } else {
                this.setState({ isLoading: false });
                this.props.history.push({ pathname: Dashboard.routeName })
                this.props.keepUser(response.data);
            }
            this.props.history.push({ pathname: Dashboard.routeName })
            this.props.keepUser(response.data);


        } if (response.message == "Invalid User Id") {
            this.setState({ errorMessage: response.message, isLoading: false })

        }
        else if (response.message === "Invalid Password") {
            this.setState({
                errorMessage: response.message,
                isLoading: false,

            })
        } else {

            this.setState({
                errorMessage: response.message,
                attemptsMessge: "",
            })
        }
    }

    ToSignUpPage() {
        this.props.history.push({ pathname: `/SignUp`, state: 0 })
    }

    render() {
        return (

            <div className="app flex-row align-items-center">
                {this.state.isLoading && <LoadingSpinner />}
                {!this.state.changeScreen ?
                    <Container>
                        <Row className="justify-content-center">
                            <Col md="8">
                                <Modal autoFocus={false} style={{ marginTop: 0, marginBottom: 0 }} isOpen={this.state.OTPModal} toggle={() => this.toggle()} className="app flex-row align-items-center" size="lg" >

                                </Modal>
                                <CardGroup>
                                    <Card className="p-4">
                                        <CardBody>
                                            {this.state.errorMessage !== "" &&
                                                <Alert color="danger">{this.state.errorMessage}</Alert>
                                            }
                                            <form action="">
                                                <h1>Login</h1>
                                                <p className="text-muted">Login In Eload Portal</p>
                                                <InputGroup className="mb-3">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="fa fa-phone"></i>
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input autoFocus="autofocus" type="text" name="username" value={this.state.loginId} onChange={(e) => this.updateState("loginId", e.target.value)} placeholder="Phone Number" />
                                                </InputGroup>
                                                <InputGroup className="mb-4">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="fa fa-lock fa-lg"></i>
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input type="password" name="password" value={this.state.password} onChange={(e) => this.updateState("password", e.target.value)} placeholder="Password" />
                                                </InputGroup>
                                                <Row>
                                                    <Col xs="6  ">
                                                        <Button color="primary" className="px-4" type="submit" onClick={this.submitHandle
                                                        }>Login</Button>
                                                    </Col>
                                                    <Col xs="6" className="text-right">
                                                        <Button onClick={() => null} color="link" className="px-0">Forgot password?</Button>
                                                    </Col>
                                                </Row>
                                                <div style={{ marginTop: 10 }}>
                                                    <Button onClick={() => this.ToSignUpPage()} color="link" className="px-0">Are you new user ?</Button>
                                                </div>
                                            </form>
                                            <Row>
                                                <p className="text-muted">Version - {AppConfiguration.Setting().AppVersion}</p>
                                                <p style={{ fontSize: "10px", color: '#73818f' }}>{AppConfiguration.Setting().VersionCode}</p>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                    <Card className="text-white bg-light py-5 d-md-down-none" style={{ width: 44 + '%' }}>
                                        <CardBody className="text-center">
                                            <div style={{ lineHeight: 1 }}>
                                                <img src={logo} width="250" height="250" alt="ELM" />
                                            </div>
                                        </CardBody>
                                    </Card>
                                </CardGroup>
                                {
                                    this.state.attemptsMessge !== "" &&
                                    <Alert toggle={() => this.setState({ attemptsMessge: "" })} color="warning"><strong>{this.state.attemptsMessge}</strong></Alert>
                                }

                            </Col>
                        </Row>
                    </Container>
                    :
                    <Container>
                        <Row className="justify-content-center">
                            <Col md="8">
                                <CardGroup>
                                    <Card className="p-4">
                                        <CardBody>
                                            {this.state.errorMessage !== "" &&
                                                <Alert color="danger">{this.state.errorMessage}</Alert>
                                            }
                                            <form action="">
                                                <p className="text-muted">Please Change Your Password</p>
                                                <InputGroup className="mb-4">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="fa fa-lock fa-lg"></i>
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input type="password" name="newpassword" value={this.state.newPassword} onChange={(e) => this.updateState("newPassword", e.target.value)} placeholder="New Password" />
                                                </InputGroup>
                                                <InputGroup className="mb-4">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="fa fa-lock fa-lg"></i>
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input type="password" name="confirmpassword" value={this.state.confirmPassword} onChange={(e) => this.updateState("confirmPassword", e.target.value)} placeholder="Confirm Password" />
                                                </InputGroup>
                                                <Row>
                                                    <Col xs="6">
                                                        <Button color="primary" className="px-4" type="button" onClick={() => this.ChangePassword()
                                                        }>Change</Button>
                                                    </Col>
                                                </Row>
                                            </form>
                                        </CardBody>
                                    </Card>
                                    <Card className="text-white bg-light py-5 d-md-down-none" style={{ width: 44 + '%' }}>
                                        <CardBody className="text-center">
                                            <div >
                                                <br /><br />
                                                <img src={logo} width="300" height="auto" alt="GNM" />
                                            </div>
                                        </CardBody>
                                    </Card>
                                </CardGroup>
                                {
                                    this.state.attemptsMessge !== "" &&
                                    <Alert toggle={() => this.setState({ attemptsMessge: "" })} color="warning"><strong>{this.state.attemptsMessge}</strong></Alert>
                                }
                            </Col>
                        </Row>
                    </Container>
                }
            </div>
        );
    }
}
function mapStateToProps(state) {
    return { auth: state.auth };
}

export default connect(mapStateToProps, actions)(Login);
